"use strict";
/**
 * Schedule slot suggestions - shared contract between the suggestScheduleSlots
 * callable and the Reportan Web and Mobile suggestion panels.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSuggestionDay = formatSuggestionDay;
exports.describeNoteRules = describeNoteRules;
exports.explainSlotCandidate = explainSlotCandidate;
// Plain-language rendering shared by web and mobile. Day/month is formatted by hand
// because Hermes on older Android builds lacks full Intl.DateTimeFormat support.
const WEEKDAYS = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
function formatSuggestionDay(date) {
    const day = new Date(`${date}T00:00:00Z`);
    return `יום ${WEEKDAYS[day.getUTCDay()]} ${day.getUTCDate()}.${day.getUTCMonth() + 1}`;
}
function describeNoteRules(rules) {
    if (!rules)
        return null;
    const parts = [
        rules.minStart ? `אחרי ${rules.minStart}` : null,
        rules.maxStart ? `עד ${rules.maxStart}` : null,
        rules.onlyWeekdays?.length ? `רק ביום ${rules.onlyWeekdays.map((day) => WEEKDAYS[day]).join(', ')}` : null,
        rules.excludedWeekdays.length ? `לא ביום ${rules.excludedWeekdays.map((day) => WEEKDAYS[day]).join(', ')}` : null,
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(' · ') : null;
}
/** Plain-language reasons built only from the numbers the server computed. */
function explainSlotCandidate(candidate, rules) {
    // Absent when the callable predates the day route; see SlotSuggestions.
    const legs = candidate.legs ?? {};
    const reasons = [];
    if (candidate.openDay) {
        reasons.push(candidate.nearbyVisit
            ? `יום ריק לבודק. הביקור הקרוב שלו: ${formatSuggestionDay(candidate.nearbyVisit.date)} ${candidate.nearbyVisit.time}, ${candidate.nearbyVisit.minutes} דק׳ נסיעה מכאן`
            : `יום ריק לבודק ואין לו ביקורים סמוכים, לכן נספרו ${candidate.addedMinutes} דק׳ קבועות`);
    }
    else if (legs.direct !== undefined && legs.toNew !== undefined && legs.fromNew !== undefined) {
        reasons.push(`נכנס בין שני ביקורים: ${legs.toNew} + ${legs.fromNew} דק׳ במקום ${legs.direct} דק׳ ישירות, תוספת ${candidate.addedMinutes} דק׳`);
    }
    else if (legs.toNew !== undefined) {
        reasons.push(`אחרי הביקור של ${candidate.previousVisit?.time}: ${legs.toNew} דק׳ נסיעה`);
    }
    else if (legs.fromNew !== undefined) {
        reasons.push(`לפני הביקור של ${candidate.nextVisit?.time}: ${legs.fromNew} דק׳ נסיעה`);
    }
    if (candidate.dayLoad > 0)
        reasons.push(`${candidate.dayLoad + 1} ביקורים לבודק ביום הזה אחרי השיבוץ`);
    const note = describeNoteRules(rules);
    if (note)
        reasons.push(`עומד בהערה: ${note}`);
    if (candidate.approximate)
        reasons.push('חלק מזמני הנסיעה משוערים');
    return reasons;
}
